// App.js - Bu değişiklikleri yapın

import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useParams } from 'react-router-dom';

import { ValuationProvider } from './context/ValuationContext';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import './utils/axiosConfig'; // Axios interceptor'ı yükle 

import Login from './seedScorePages/Auth/Login/Login';
import Register from './seedScorePages/Auth/Register/Register';
import PaymentRegister from './seedScorePages/Auth/PaymentRegister/PaymentRegister';
// YENİ EKLEMELER - Email verification komponenleri
import EmailVerification from './seedScorePages/Auth/EmailVerification/EmailVerification';
import ResendVerification from './seedScorePages/Auth/ResendVerification/ResendVerification';
import ForgotPassword from './seedScorePages/Auth/ForgotPassword/ForgotPassword';
import ResetPassword from './seedScorePages/Auth/ResetPassword/ResetPassword';
import Landing from './seedScorePages/Landing/Landing';
import EntrepreneurInfo from './seedScorePages/infoForm/entrepreneurInfo';
import FinancialTable from './seedScorePages/FinancialTable/FinancialTable';
import AssessmentForm from './seedScorePages/AssestmentForm/AssesstmentForm'; 
import ValuationReport from './seedScorePages/MainReport/ValuationReport';
import Report from './seedScorePages/Report/Report';
import Dashboard from './seedScorePages/Dashboard/Dashboard';
import Shop from './seedScorePages/Shop/Shop';
import PaymentSuccess from './seedScorePages/Payment/PaymentSuccess';
import PaymentError from './seedScorePages/Payment/PaymentError';
import Profile from './seedScorePages/Profile/Profile';
import LinkSubmissions from './seedScorePages/LinkSubmissions/LinkSubmissions';
import SharedEntrepreneurInfo from './seedScorePages/SharedPages/SharedEntrepreneurInfo';
import SharedAssessment from './seedScorePages/SharedPages/SharedAssessment';
import SharedFinancialTable from './seedScorePages/SharedPages/SharedFinancialTable';
import SharedForm from './seedScorePages/SharedForm/SharedForm';
import { SharedFormProvider } from './context/SharedFormContext';
import SharedSuccess from './seedScorePages/SharedPages/SharedSuccess';

import { ToastProvider } from './context/ToastContext/ToastContext';


function LinkSubmissionsWrapper() {
  const navigate = useNavigate();
  const { linkId } = useParams(); 

  return (
    <LinkSubmissions 
      linkId={linkId} // 🔥 eksik olan kısım bu
      onBack={() => navigate('/dashboard')}
      onViewReport={(reportId) => navigate(`/dashboard/report/${reportId}`)}
    />
  );
}

function App() {
  return (
    <ToastProvider>
    <ValuationProvider>
      <SharedFormProvider>
        <Router>
          <div className="App">
            <Routes>
              {/* PUBLIC ROUTES */}
              <Route path="/" element={<Login />} />
              <Route path="/register" element={<PaymentRegister />} />
              <Route path="/payment-register" element={<PaymentRegister />} />
              <Route path="/verify-email/:token" element={<EmailVerification />} />
              <Route path="/resend-verification" element={<ResendVerification />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="/landing" element={<Landing />} />

              {/* SHARED FORM ROUTES - PUBLIC (Token ile korunuyor) */}
              <Route path="/shared-form/:token" element={<SharedForm />} />
              <Route path="/shared-form/:token/entrepreneur-info" element={<SharedEntrepreneurInfo />} />
              <Route path="/shared-form/:token/financial-table" element={<SharedFinancialTable />} />
              <Route path="/shared-form/:token/assessment" element={<SharedAssessment />} />
              <Route path="/shared-form/:token/success" element={<SharedSuccess />} />

              {/* PROTECTED ROUTES */}
              <Route 
                path="/entrepreneur-info" 
                element={<ProtectedRoute><EntrepreneurInfo /></ProtectedRoute>} 
              />
              <Route 
                path="/financial-table" 
                element={<ProtectedRoute><FinancialTable /></ProtectedRoute>} 
              />
              <Route 
                path="/assessment"  
                element={<ProtectedRoute><AssessmentForm /></ProtectedRoute>} 
              />
              <Route 
                path="/valuation-report" 
                element={<ProtectedRoute><ValuationReport /></ProtectedRoute>} 
              />
              <Route 
                path="/dashboard/report/:reportId" 
                element={<ProtectedRoute><Report /></ProtectedRoute>} 
              />
              <Route 
                path="/dashboard" 
                element={<ProtectedRoute><Dashboard /></ProtectedRoute>} 
              />
              <Route
                path="/shop"
                element={<ProtectedRoute><Shop /></ProtectedRoute>}
              />
              <Route
                path="/profile"
                element={<ProtectedRoute><Profile /></ProtectedRoute>}
              />
              <Route 
                path="/link-submissions/:linkId" 
                element={<ProtectedRoute><LinkSubmissionsWrapper /></ProtectedRoute>} 
              />

              {/* PAYMENT ROUTES */}
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/error" element={<PaymentError />} />
            </Routes>
          </div>
        </Router>
      </SharedFormProvider>
    </ValuationProvider>
    </ToastProvider>
  );
}

export default App;